import SpeechBubble from './src/speech-bubble-combined';
export default SpeechBubble;